import React from 'react';
import PropTypes from 'prop-types';
import {
  Table, Button, Message, Segment, Header, Icon,
} from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import { TRANSACTION_COLUMNS } from '../../constants/forceGuarantee';

// Displays the transactions for a VIN, lets the user pick exactly one and
// triggers the eligibility run.
function TransactionList({
  transactions,
  selectedId,
  onSelect,
  onRunEligibility,
  eligibilityLoading,
  disabled,
  vin,
}) {
  if (isEmpty(transactions)) {
    return (
      <Segment disabled textAlign='center' data-testid='force-guarantee-no-transactions'>
        <Header icon>
          <Icon name='search' />
          {vin
            ? `No transactions found for VIN ${vin} and the selected product.`
            : 'No transactions to display. Search by VIN above.'}
        </Header>
      </Segment>
    );
  }

  return (
    <div>
      <Message info>
        <Message.Header>Select a transaction</Message.Header>
        <p>Choose the transaction to run eligibility checks against.</p>
      </Message>
      <Table selectable celled data-testid='force-guarantee-transaction-table'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell />
            {TRANSACTION_COLUMNS.map(col => (
              <Table.HeaderCell key={col.key}>{col.label}</Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {transactions.map(txn => {
            const isSelected = txn.id === selectedId;
            return (
              <Table.Row
                key={txn.id}
                active={isSelected}
                onClick={disabled ? undefined : () => onSelect(txn.id)}
                style={{ cursor: disabled ? 'default' : 'pointer' }}
                data-testid={`force-guarantee-transaction-row-${txn.id}`}
              >
                <Table.Cell collapsing>
                  <Icon
                    name={isSelected ? 'dot circle outline' : 'circle outline'}
                    color={isSelected ? 'blue' : 'grey'}
                  />
                </Table.Cell>
                {TRANSACTION_COLUMNS.map(col => (
                  <Table.Cell key={col.key}>
                    {col.format ? col.format(txn[col.key]) : txn[col.key]}
                  </Table.Cell>
                ))}
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
      <Button
        content='Run Eligibility Check'
        primary
        onClick={onRunEligibility}
        disabled={disabled || !selectedId || eligibilityLoading}
        loading={eligibilityLoading}
        data-testid='force-guarantee-run-eligibility-button'
      />
    </div>
  );
}

TransactionList.propTypes = {
  transactions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func.isRequired,
  onRunEligibility: PropTypes.func.isRequired,
  eligibilityLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  vin: PropTypes.string,
};

TransactionList.defaultProps = {
  transactions: [],
  selectedId: null,
  eligibilityLoading: false,
  disabled: false,
  vin: '',
};

export default TransactionList;
